// extracted by mini-css-extract-plugin
export default {"cardContentContainer":"CardContent_cardContentContainer__1xPz9"};